import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.deleteConfirmTitle'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.Common.deleteButton'),
        color: _vm.color,
        emit: 'delete'
      }],
      "color": _vm.color
    },
    on: {
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": _vm.deleteItem
    }
  }), _c(VRow, [_c(VCol, {
    staticClass: "pb-0"
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "search_deviceType",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": ""
    },
    on: {
      "click:clear": function ($event) {
        return _vm.updateSearchParams('');
      }
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1)], 1), _c(VDataTable, {
    attrs: {
      "data-cy": "devicetypes_list",
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.tableFooterProps,
      "item-key": "id",
      "page": _vm.tableOptions.page
    },
    on: {
      "update:options": [function ($event) {
        _vm.tableOptions = $event;
      }, _vm.updatePagination],
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('router-link', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "to": `/niota-classic/device-types/${items.item.id}/details`,
            "tag": "tr"
          }
        }, [_c('td', {
          staticClass: "px-0 text-center",
          staticStyle: {
            "width": "70px"
          }
        }, [_vm._v(_vm._s(items.item.id))]), _c('td', {
          staticClass: "clickable",
          staticStyle: {
            "width": "40px"
          }
        }, [items.item.image ? [_c(VAvatar, {
          attrs: {
            "size": "30"
          }
        }, [_c('img', {
          attrs: {
            "src": `${_vm.niota1ImageUrl(items.item.image)}`
          }
        })])] : [_c(VIcon, {
          attrs: {
            "color": _vm.color
          }
        }, [_vm._v("fal fa-cubes")])]], 2), _c('td', [_c('router-link', {
          attrs: {
            "to": `/niota-classic/device-types/${items.item.id}/details`
          }
        }, [items.item.properties && items.item.properties.certified ? _c(VIcon, {
          attrs: {
            "color": "green",
            "small": ""
          }
        }, [_vm._v("\n              fal fa-badge-check\n            ")]) : _vm._e(), _vm._v("\n            " + _vm._s(items.item.title) + "\n          ")], 1)], 1), _c('td', [_vm._v(_vm._s(_vm.getVisibilityDisplayString(items.item.visibility)))]), _c('td', [_vm._v(_vm._s(items.item.accountname))]), _c('td', [_vm._v(_vm._s(_vm.getParserDisplayString((items.item.parser || {}).type)))]), _c('td', [_vm._v(_vm._s(_vm.localizeDate(items.item.createdAt)))]), _vm.isIotHubManager ? _c('td', {
          staticClass: "text-right"
        }, [items.item.permission ? _c('div', [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "data-cy": "edit_btn",
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.editItem(items.item);
            }
          }
        }, [_vm._v("\n              fal fa-edit\n            ")]), _vm._v("\n             \n            "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "data-cy": "delete_btn",
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.showDeletePrompt(items.item);
            }
          }
        }, [_vm._v("\n              fal fa-trash-alt\n            ")])], 1) : _vm._e(), !items.item.permission ? _c('router-link', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "to": `/niota-classic/device-types/${items.item.id}/details`,
            "tag": "div"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": "",
            "data-cy": "edit_devicetype"
          }
        }, [_vm._v("fal fa-eye")])], 1) : _vm._e()], 1) : _vm._e()])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n          " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n        ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };